import {
   ADD_TOURISTTYPE ,
   UPDATE_TOURISTTYPE ,
   DELETE_TOURISTTYPE ,
  ERROR,
  GET_ALL_TOURISTTYPE
} from "../type";

const inital = {
  createTouristType: [],
  deleteTouristType: [],
  GetallTouristType: [],
  UpdateTouristType: [],
  loading: true,
  error:[],
};
const TouristReduser = (state = inital, action) => {
  switch (action.type) {
    case ADD_TOURISTTYPE:
      return {
        GetallTouristType: state.GetallTouristType,
        createTouristType: action.payload,
        loading: false,
      };
      case DELETE_TOURISTTYPE:
        return {
          GetallTouristType: state.GetallTouristType,
          deleteTouristType: action.payload,
          loading: false,
        };
    case GET_ALL_TOURISTTYPE:
      return {
        ...state,
        GetallTouristType: action.payload,
        loading: false,
      };
      case UPDATE_TOURISTTYPE:
        return {
          GetallTouristType: state.GetallTouristType,
          UpdateTouristType: action.payload,
          loading: false,
        };
    case ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
export default TouristReduser;
